import React from 'react';

import ArrowRouteIcon from '../../../assets/arrow-route-icon';
import ClockIcon from '../../../assets/clock-icon';
import SeatPassIcon from '../../../assets/seat-pass-icon';
import AngleRightIcon from '../../../assets/angle-right-icon';

export const RouteOriginToDestination = ({ origin, destination, travelTime, isFetching }) => {
  return (
    <div className="flex flex-col md:flex-row flex-1 justify-start item-start md:items-center gap-5 md:gap-10">
      {isFetching ? (
        <div className="h-12 w-full rounded bg-gray-200 animate-pulse" />
      ) : (
        <>
          <div className="flex flex-col items-start">
            {origin?.city && (
              <span className="text-left text-sm md:text-base text-[#757575]">{origin?.city}</span>
            )}
            <span className="text-left text-base md:text-xl font-semibold">{origin?.name}</span>
          </div>
          <div className="flex flex-1 justify-start md:justify-center items-center flex-row md:flex-col">
            <div className="rotate-90 md:rotate-0">
              <ArrowRouteIcon />
            </div>
            {travelTime}
          </div>
          <div className="flex flex-col items-start md:items-end">
            {destination?.city && (
              <span className="text-left md:text-right text-sm md:text-base text-[#757575]">
                {destination?.city}
              </span>
            )}
            <span className="text-left md:text-right text-base md:text-xl font-semibold">
              {destination?.name}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

const OriginDestinationListItem = ({
  company,
  origin,
  destination,
  travelTime,
  departureTime,
  busType,
  busClass,
  cost,
  onClick,
  facilities,
  seat,
  seatLayout
}) => {
  return (
    <div className="flex flex-col p-5 rounded-lg bg-white gap-4 border">
      <div className="flex justify-start items-center gap-1 md:gap-4">
        <img src={company?.logo} alt="-" className="max-h-16 w-full max-w-[116px] object-cover" />
        <h3 className="flex flex-1 font-bold text-left">{company?.name}</h3>
      </div>
      <RouteOriginToDestination origin={origin} destination={destination} travelTime={travelTime} />
      <div className="flex justify-between">
        <div className="flex gap-1 border border-gray-400 justify-center items-center rounded-full p-1">
          <ClockIcon />
          <h3 className="text-sm md:text-base">{departureTime}</h3>
        </div>
        <div className="flex justify-center items-center gap-1">
          <span className="flex text-left text-sm text-white px-2 py-1 bg-primary-500 rounded-full">
            {busType}
          </span>
          <span className="flex text-left text-sm text-white px-2 py-1 bg-gray-500 rounded-full">
            {busClass}
          </span>
        </div>
      </div>
      <hr />
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-1 md:gap-0">
        <div className="flex flex-grow items-center justify-start gap-2">
          {facilities?.map((item) => (
            <img src={item?.icon} alt={item?.name} />
          ))}
          <span>|</span>
          <span className="border border-black rounded p-1">{seatLayout}</span>
          <span className="flex items-center">
            <SeatPassIcon />
            {seat} Seat
          </span>
        </div>
        <div className="flex bg justify-between md:justify-end items-center gap-2">
          <h3 className="font-bold text-xl">{cost}</h3>
          <button
            onClick={onClick}
            type="button"
            className="text-black bg-secondary-800 inline-flex items-center gap-1 font-medium rounded-lg text-base px-3 py-2 focus:outline-none"
          >
            PILIH
            <AngleRightIcon color="black" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OriginDestinationListItem;
